import { useQuery } from '@tanstack/react-query';

import { QueryFunction, useRequest } from '@frontend/api';

import type { SearchData } from '../common';
import {
  getUseSearchOrderItemsQueryKey,
  UseSearchOrderItemsQueryKey,
} from './keys';
import type { UseSearchOrderItemsParams } from './types';

export const useSearchOrderItems: QueryFunction<
  SearchData,
  [body: UseSearchOrderItemsParams],
  UseSearchOrderItemsQueryKey
> = (body, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useQuery({
    ...queryOptions,
    queryKey: getUseSearchOrderItemsQueryKey(body),
    queryFn: ({ signal }) =>
      request('/search/order_items', {
        init: {
          signal,
          method: 'POST',
          body,
        },
      }),
  });
};
